import { LoadList } from "./LoadList";
import { LoadCreate } from "./LoadCreate";
import { LoadShow } from "./LoadShow";
import { LoadEdit } from "./LoadEdit";

export default {
  list: LoadList,
  create: LoadCreate,
  show: LoadShow,
  edit: LoadEdit,
};
